<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerName')"
  />

  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchBySecurityType"
    type="text"
    placeholder="Search by security type"
    class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchBySecurityType')"
  />
</div>

<div class="mb-4"></div>

<p-table
  [value]="processedSecurity"
  [paginator]="processedSecurity.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedIssuers"
  dataKey="asReportedSecurityId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th>Issuer Name</th>
      <th>Security Types</th>
    </tr>
  </ng-template>
  <ng-template #body let-product>
    <tr>
      <td>{{ product.issuerName || "N/A" }}</td>
      <td>{{ product.securityTypes?.length ? product.securityTypes : 'N/A' }}</td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="!isLoading && processedSecurity.length === 0">
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-container>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
